var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',{staticClass:"pt-4 pb-5",attrs:{"md":"5","sm":"12"}},[_c('canvas',{ref:"myChart",staticStyle:{"min-height":"500px"},attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }